// extracted by mini-css-extract-plugin
module.exports = {"root":"StatisticItem_root__24sZJ","info":"StatisticItem_info__-pz3B"};